"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
let formatter, thousandSeparatorRegex, decimalSeparatorRegex, decimalSeparator;
exports.setLocale = (locale) => {
    formatter = new Intl.NumberFormat(locale, { maximumFractionDigits: 1, useGrouping: true });
    const parts = formatter.formatToParts(1234.5);
    decimalSeparator = parts[3].value;
    thousandSeparatorRegex = new RegExp('\\' + parts[1].value, 'g');
    decimalSeparatorRegex = new RegExp('\\' + decimalSeparator, 'g');
};
exports.setLocale('en-US');
function format(value, options) {
    const { locale, ...oldOptions } = formatter.resolvedOptions();
    const maximumFractionDigits = (options && options.maximumFractionDigits) ? options.maximumFractionDigits : 20;
    return new Intl.NumberFormat(locale, { ...oldOptions, ...options, maximumFractionDigits }).format(value);
}
exports.format = format;
function toFloat(value) {
    return parseFloat(value.replace(thousandSeparatorRegex, '').replace(decimalSeparatorRegex, '.'));
}
function testValidNumber(value, decimalScale) {
    return new RegExp('^-?\\d*[' + decimalSeparator + ']?\\d' + (decimalScale ? '{0,' + decimalScale + '}' : '*') + '$').test(value);
}
const NumericInput = ({ inputRef, onChange, onBlur, onFocus, maximumFractionDigits, minimumFractionDigits, useGrouping, ...props }) => {
    const [value, setValue] = react_1.useState(props.value ? format(props.value, { useGrouping, maximumFractionDigits, minimumFractionDigits }) : '');
    react_1.useEffect(() => {
        const floatValue = toFloat(value);
        if (((!isNaN(floatValue) && floatValue !== 0) || props.value) && floatValue !== props.value && props.value !== '' && typeof props.value !== 'undefined') {
            setValue(format(props.value, { useGrouping, maximumFractionDigits, minimumFractionDigits }));
        }
        else if (typeof props.value !== 'undefined' && props.value + '' === '') {
            setValue('');
        }
    }, [props.value, value, useGrouping, maximumFractionDigits, minimumFractionDigits]);
    const handleChange = react_1.useCallback((e) => {
        const stringValue = e.target.value.replace('.', decimalSeparator);
        const isValid = testValidNumber(stringValue, maximumFractionDigits);
        if (isValid || stringValue === '') {
            setValue(stringValue);
            const numberValue = toFloat(e.target.value);
            if (typeof numberValue !== 'undefined' && (!isNaN(numberValue) || stringValue === '')) {
                const newEvent = { ...e, target: { ...e.target, value: !isNaN(numberValue) ? numberValue : undefined } };
                onChange && onChange(newEvent);
            }
        }
    }, [onChange, maximumFractionDigits]);
    const handleBlur = react_1.useCallback((e) => {
        value !== '' && setValue(format(toFloat(value), { useGrouping, maximumFractionDigits, minimumFractionDigits }));
        onBlur && onBlur(e);
    }, [onBlur, value, useGrouping, maximumFractionDigits, minimumFractionDigits]);
    const handleFocus = react_1.useCallback((e) => {
        value !== '' && useGrouping && setValue(format(toFloat(value), { useGrouping: false, maximumFractionDigits, minimumFractionDigits }));
        onFocus && onFocus(e);
    }, [onFocus, value, useGrouping, maximumFractionDigits, minimumFractionDigits]);
    return react_1.default.createElement("input", Object.assign({ pattern: "\\\\d*" }, props, { value: value, onChange: handleChange, onBlur: handleBlur, onFocus: handleFocus, ref: inputRef }));
};
NumericInput.defaultProps = {
    useGrouping: false
};
exports.default = NumericInput;
//# sourceMappingURL=NumericInput.js.map